var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#FCFCFD",
    stroke: "#E6E8EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 19.25C12.8075 19.25 13.4247 18.9815 13.8927 18.5525L18.5877 21.2352C18.5322 21.444 18.5027 21.6589 18.5 21.875C18.5 23.3225 19.6775 24.5 21.125 24.5C22.5725 24.5 23.75 23.3225 23.75 21.875C23.75 20.4275 22.5725 19.25 21.125 19.25C20.4425 19.25 19.8252 19.5185 19.3573 19.9475L14.6623 17.2647C14.7095 17.0795 14.7395 16.8882 14.7432 16.6888L19.3565 14.0525C19.8253 14.4815 20.4425 14.75 21.125 14.75C22.5725 14.75 23.75 13.5725 23.75 12.125C23.75 10.6775 22.5725 9.5 21.125 9.5C19.6775 9.5 18.5 10.6775 18.5 12.125C18.5 12.347 18.536 12.5585 18.5877 12.7648L14.3247 15.2015C14.0876 14.8335 13.762 14.5307 13.3777 14.3209C12.9935 14.111 12.5628 14.0007 12.125 14C10.6775 14 9.5 15.1775 9.5 16.625C9.5 18.0725 10.6775 19.25 12.125 19.25ZM21.125 20.75C21.7452 20.75 22.25 21.2548 22.25 21.875C22.25 22.4952 21.7452 23 21.125 23C20.5048 23 20 22.4952 20 21.875C20 21.2548 20.5048 20.75 21.125 20.75ZM21.125 11C21.7452 11 22.25 11.5048 22.25 12.125C22.25 12.7452 21.7452 13.25 21.125 13.25C20.5048 13.25 20 12.7452 20 12.125C20 11.5048 20.5048 11 21.125 11ZM12.125 15.5C12.7452 15.5 13.25 16.0047 13.25 16.625C13.25 17.2453 12.7452 17.75 12.125 17.75C11.5048 17.75 11 17.2453 11 16.625C11 16.0047 11.5048 15.5 12.125 15.5Z",
    fill: "#091B2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareButton);
export default __webpack_public_path__ + "static/media/shareButton.379f013f484f32345e815b5cd74e61c3.svg";
export { ForwardRef as ReactComponent };